import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Button } from "@mui/material";
import { useEffect, useState } from "react";
import agent from "../../app/api/agent";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { Order } from "../../app/models/order";
import { useAppSelector } from "../../app/store/configureStore";
import { currencyFormat } from "../../app/util/util";
import OrderDetailed from "./OrderDetailed";

export default function Orders() {
    const { user } = useAppSelector(state => state.account);
    const [orders, setOrders] = useState<Order[] | null>(null);
    const [loading, setLoading] = useState(true);
    const [selectedOrderNumber, setSelectedOrderNumber] = useState(0);

    useEffect(() => {
        agent.Orders.list()
            .then(orders => setOrders(orders))
            .catch(error => console.log(error))
            .finally(() => setLoading(false));
    }, [])

    if (loading) return <LoadingComponent message='Loading orders' />

    if (selectedOrderNumber == -1) {
        setLoading(true);
        agent.Orders.list()
        .then(orders => setOrders(orders))
        .catch(error => console.log(error))
        .finally(() => setLoading(false));
        setSelectedOrderNumber(0);
    }

    if (selectedOrderNumber > 0) return (
        <OrderDetailed 
            order={orders?.find(o => o.id === selectedOrderNumber)!}
            setSelectedOrder={setSelectedOrderNumber}
        />
    )

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell >Order number</TableCell>
                        <TableCell >Name</TableCell>
                        <TableCell >Email</TableCell>
                        <TableCell >Phone Number</TableCell>
                        <TableCell >Total</TableCell>
                        <TableCell >Order Date</TableCell>
                        <TableCell >Order Status</TableCell>
                        <TableCell ></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {orders?.map((order) => (
                        <TableRow
                            key={order.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {order.id}
                            </TableCell>
                            <TableCell >{order.shippingAddress_FullName}</TableCell>
                            <TableCell >{order.email}</TableCell>
                            <TableCell >{order.phoneNumber}</TableCell>
                            <TableCell >{currencyFormat(order.total)}</TableCell>
                            <TableCell >{order.orderDate.split('T')[0]}</TableCell>
                            <TableCell >{order.orderStatus}</TableCell>
                            <TableCell align="right">
                                <Button onClick={() => setSelectedOrderNumber(order.id)}>
                                    View
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}